var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isEnabled && _vm.hasContent)?_c('div',{ref:"bar",staticClass:"m-announcement-bar"},[_c('div',{staticClass:"m-announcement-bar__content"},[_c('div',{ref:"content",staticClass:"m-announcement-bar__html"})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }